(function () {
  'use strict';

  var island = document.getElementById('ksl-compare-data');
  var root = document.querySelector('[data-kslc-root]');
  if (!island || !root) return;

  var data;
  try { data = JSON.parse(island.textContent); } catch (error) { return; }

  var products = Array.isArray(data.products) ? data.products : [];
  var categories = Array.isArray(data.categories) ? data.categories : [];
  var specMap = Array.isArray(data.specs) ? data.specs : [];
  var tabs = root.querySelector('[data-kslc-tabs]');
  var picker = root.querySelector('[data-kslc-picker]');
  var selectedBar = root.querySelector('[data-kslc-selected-bar]');
  var countButton = root.querySelector('[data-kslc-count]');
  var countLabel = root.querySelector('[data-kslc-count-label]');
  var thumbs = root.querySelector('[data-kslc-thumbs]');
  var guidance = root.querySelector('[data-kslc-guidance]');
  var clearButton = root.querySelector('[data-kslc-clear]');
  var capMessage = root.querySelector('[data-kslc-cap]');
  var compareButton = root.querySelector('[data-kslc-compare]');
  var tray = root.querySelector('[data-kslc-tray]');
  var results = root.querySelector('[data-kslc-results]');
  if (!tabs || !picker || !selectedBar || !countButton || !compareButton || !tray || !results) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var byHandle = {};
  products.forEach(function (product) { byHandle[product.handle] = product; });
  categories = categories.filter(function (category) {
    return products.some(function (product) { return product.cat === category.slug; });
  });

  var activeCategory = '';
  var selected = [];
  var compareVersion = 0;

  function updateUrl() {
    if (!activeCategory || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('cat', activeCategory);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function setActiveTab() {
    tabs.querySelectorAll('[data-kslc-tab]').forEach(function (button) {
      var active = button.getAttribute('data-kslc-tab') === activeCategory;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function clearResults() {
    compareVersion += 1;
    results.hidden = true;
    results.innerHTML = '';
  }

  function selectCategory(slug, preselectHandle) {
    if (!categories.some(function (category) { return category.slug === slug; })) return;
    var changed = activeCategory && activeCategory !== slug;
    activeCategory = slug;
    if (changed) selected = [];
    if (preselectHandle && byHandle[preselectHandle] && byHandle[preselectHandle].cat === slug) {
      selected = [byHandle[preselectHandle]];
    }
    setActiveTab();
    clearResults();
    renderPicker();
    renderSelectedBar();
    updateUrl();
  }

  function renderTabs() {
    tabs.innerHTML = '';
    categories.forEach(function (category) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'kslc__tab';
      button.setAttribute('role', 'tab');
      button.setAttribute('data-kslc-tab', category.slug);
      button.textContent = category.label;
      button.addEventListener('click', function () {
        if (activeCategory !== category.slug) selectCategory(category.slug);
      });
      tabs.appendChild(button);
    });
  }

  function isSelected(handle) {
    return selected.some(function (product) { return product.handle === handle; });
  }

  function showCapMessage() {
    if (!capMessage) return;
    capMessage.hidden = false;
    window.clearTimeout(showCapMessage.timer);
    showCapMessage.timer = window.setTimeout(function () { capMessage.hidden = true; }, 2200);
  }

  function toggleProduct(product, checked, card, input) {
    if (checked && selected.length >= 4) {
      input.checked = false;
      showCapMessage();
      return;
    }
    if (checked) selected.push(product);
    else selected = selected.filter(function (item) { return item.handle !== product.handle; });
    card.classList.toggle('is-selected', checked);
    clearResults();
    renderSelectedBar();
    updateUrl();
  }

  function renderPicker() {
    picker.innerHTML = '';
    products.filter(function (product) { return product.cat === activeCategory; }).forEach(function (product) {
      var card = document.createElement('article');
      card.className = 'kslc-card' + (isSelected(product.handle) ? ' is-selected' : '');
      card.setAttribute('data-kslc-card', product.handle);

      var link = document.createElement('a');
      link.className = 'kslc-card__link';
      link.href = product.url;
      if (product.image) {
        var imageWell = document.createElement('span');
        imageWell.className = 'kslc-card__image-well';
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        imageWell.appendChild(image);
        link.appendChild(imageWell);
      }
      var body = document.createElement('span');
      body.className = 'kslc-card__body';
      var title = document.createElement('span');
      title.className = 'kslc-card__title';
      title.textContent = product.title;
      var price = document.createElement('span');
      price.className = 'kslc-card__price';
      price.textContent = product.price;
      body.appendChild(title);
      body.appendChild(price);
      link.appendChild(body);
      card.appendChild(link);

      var pick = document.createElement('label');
      pick.className = 'kslc-card__pick';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = isSelected(product.handle);
      input.setAttribute('aria-label', 'Compare ' + product.title);
      var pickText = document.createElement('span');
      pickText.textContent = 'Compare';
      pick.appendChild(input);
      pick.appendChild(pickText);
      pick.addEventListener('click', function (event) { event.stopPropagation(); });
      input.addEventListener('change', function () { toggleProduct(product, input.checked, card, input); });
      card.appendChild(pick);
      picker.appendChild(card);
    });
  }

  function findCard(handle) {
    return Array.prototype.find.call(picker.querySelectorAll('[data-kslc-card]'), function (card) {
      return card.getAttribute('data-kslc-card') === handle;
    });
  }

  function jumpToCard(handle) {
    var card = findCard(handle);
    if (!card) return;
    closeTray();
    card.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    var input = card.querySelector('input[type="checkbox"]');
    if (input) input.focus({ preventScroll: true });
    card.classList.remove('is-flashing');
    if (!reducedMotion) {
      void card.offsetWidth;
      card.classList.add('is-flashing');
      window.setTimeout(function () { card.classList.remove('is-flashing'); }, 1200);
    }
  }

  function removeProduct(handle) {
    var removedIndex = selected.findIndex(function (product) { return product.handle === handle; });
    var restoreFocus = tray.contains(document.activeElement);
    selected = selected.filter(function (product) { return product.handle !== handle; });
    var card = findCard(handle);
    if (card) {
      card.classList.remove('is-selected');
      var input = card.querySelector('input[type="checkbox"]');
      if (input) input.checked = false;
    }
    clearResults();
    renderSelectedBar();
    updateUrl();
    if (restoreFocus) {
      var remaining = tray.querySelectorAll('.kslc__tray-remove');
      var target = remaining[Math.min(removedIndex, remaining.length - 1)];
      if (selected.length) (target || countButton).focus({ preventScroll: true });
      else if (card) card.querySelector('input').focus({ preventScroll: true });
    }
  }

  function renderTray() {
    tray.innerHTML = '';
    selected.forEach(function (product) {
      var row = document.createElement('div');
      row.className = 'kslc__tray-row';
      var jump = document.createElement('button');
      jump.type = 'button';
      jump.className = 'kslc__tray-jump';
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        jump.appendChild(image);
      }
      var name = document.createElement('span');
      name.textContent = product.title;
      jump.appendChild(name);
      jump.setAttribute('aria-label', 'Find ' + product.title + ' in product selection');
      jump.addEventListener('click', function () { jumpToCard(product.handle); });
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'kslc__tray-remove';
      remove.setAttribute('aria-label', 'Remove ' + product.title + ' from comparison');
      remove.textContent = '×';
      remove.addEventListener('click', function () { removeProduct(product.handle); });
      row.appendChild(jump);
      row.appendChild(remove);
      tray.appendChild(row);
    });
  }

  function closeTray() {
    tray.hidden = true;
    countButton.setAttribute('aria-expanded', 'false');
  }

  function renderSelectedBar() {
    selectedBar.hidden = selected.length === 0;
    countLabel.textContent = selected.length + ' of 4 selected';
    countButton.setAttribute('aria-label', selected.length + ' products selected. View or remove selected products');
    guidance.textContent = selected.length < 2 ? 'Choose 1 more to compare' : 'View your selection';
    thumbs.innerHTML = '';
    selected.forEach(function (product) {
      var thumb = document.createElement('span');
      thumb.className = 'kslc__thumb';
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        thumb.appendChild(image);
      }
      thumbs.appendChild(thumb);
    });
    compareButton.disabled = selected.length < 2;
    compareButton.removeAttribute('aria-busy');
    compareButton.removeAttribute('aria-label');
    if (!selected.length) closeTray();
    else if (!tray.hidden) renderTray();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' }).format(Number(cents || 0) / 100);
  }

  function refreshProduct(product) {
    return fetch('/products/' + encodeURIComponent(product.handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      })
      .then(function (live) {
        var variants = Array.isArray(live.variants) ? live.variants : [];
        var variant = variants.filter(function (item) { return item.available; })[0] || variants[0] || {};
        return {
          product: product,
          title: live.title || product.title,
          price: variant.price == null ? live.price : variant.price,
          available: !!variant.available,
          variantId: variant.id || product.variantId
        };
      });
  }

  function productHead(item) {
    var product = item.product;
    var html = '<div class="kslc__result-cell kslc__result-head">';
    html += '<a class="kslc__result-product" href="' + escapeHtml(product.url) + '">';
    if (product.image) html += '<span class="kslc__result-image"><img src="' + escapeHtml(product.image) + '" alt="" loading="lazy"></span>';
    html += '<span class="kslc__result-title">' + escapeHtml(item.title) + '</span></a>';
    html += '<span class="kslc__result-price">' + escapeHtml(money(item.price)) + '</span>';
    if (item.available) {
      html += '<form action="/cart/add" method="post" enctype="multipart/form-data" data-ksl-card-atc><input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '"><button type="submit" class="ksl-card-atc"><span class="ksl-card-atc__label">Add to cart</span></button></form>';
    } else {
      html += '<span class="kslc__sold-out">Sold out</span>';
    }
    html += '<a class="kslc__view" href="' + escapeHtml(product.url) + '">View product</a></div>';
    return html;
  }

  function renderResults(liveProducts) {
    var html = '<div class="kslc__scrollwrap" style="--cols:' + liveProducts.length + '"><div class="kslc__table">';
    html += '<div class="kslc__result-row kslc__result-row--head"><div class="kslc__result-label" aria-hidden="true"></div>';
    liveProducts.forEach(function (item) { html += productHead(item); });
    html += '</div>';

    specMap.filter(function (spec) {
      return liveProducts.some(function (item) { return String(item.product.specs[spec.key] || '').trim() !== ''; });
    }).forEach(function (spec) {
      var values = liveProducts.map(function (item) { return String(item.product.specs[spec.key] || ''); });
      var differs = values.some(function (value) { return value !== values[0]; });
      html += '<div class="kslc__result-row' + (differs ? ' kslc__result-row--different' : '') + '">';
      html += '<div class="kslc__result-label">' + escapeHtml(spec.label) + '</div>';
      values.forEach(function (value) {
        html += '<div class="kslc__result-cell kslc__spec-cell">' + (value.trim() ? escapeHtml(value) : '<span class="kslc__absent">—</span>') + '</div>';
      });
      html += '</div>';
    });
    html += '</div></div>';
    results.innerHTML = html;
    results.hidden = false;
    results.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function compareSelected() {
    if (selected.length < 2) return;
    closeTray();
    var version = ++compareVersion;
    compareButton.disabled = true;
    compareButton.setAttribute('aria-busy', 'true');
    compareButton.setAttribute('aria-label', 'Loading comparison');
    Promise.all(selected.map(refreshProduct)).then(function (liveProducts) {
      if (version !== compareVersion) return;
      renderResults(liveProducts);
    }).catch(function () {
      if (version !== compareVersion) return;
      results.innerHTML = '<p class="kslc__error">Comparison data could not be loaded. Please try again.</p>';
      results.hidden = false;
    }).then(function () {
      if (version === compareVersion) renderSelectedBar();
    });
  }

  countButton.addEventListener('click', function () {
    if (!selected.length) return;
    if (tray.hidden) {
      renderTray();
      tray.hidden = false;
      countButton.setAttribute('aria-expanded', 'true');
      var first = tray.querySelector('button');
      if (first) first.focus({ preventScroll: true });
    } else closeTray();
  });
  clearButton.addEventListener('click', function () {
    var firstCard = selected.length && findCard(selected[0].handle);
    selected = [];
    picker.querySelectorAll('[data-kslc-card]').forEach(function (card) {
      card.classList.remove('is-selected');
      card.querySelector('input[type="checkbox"]').checked = false;
    });
    clearResults();
    renderSelectedBar();
    updateUrl();
    if (firstCard) firstCard.querySelector('input').focus({ preventScroll: true });
  });
  selectedBar.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !tray.hidden) {
      event.preventDefault();
      closeTray();
      countButton.focus({ preventScroll: true });
    }
  });
  selectedBar.addEventListener('focusout', function (event) {
    if (event.relatedTarget && !selectedBar.contains(event.relatedTarget)) closeTray();
  });
  compareButton.addEventListener('click', compareSelected);
  document.addEventListener('click', function (event) {
    if (!tray.hidden && event.target.isConnected && !selectedBar.contains(event.target)) closeTray();
  });

  renderTabs();
  if (!categories.length) {
    picker.innerHTML = '<p class="kslc__empty">No products with comparison specifications are available yet.</p>';
    return;
  }
  var params = new URLSearchParams(window.location.search);
  var initialCategory = params.get('cat');
  var initialHandle = params.get('from');
  if (!categories.some(function (category) { return category.slug === initialCategory; })) initialCategory = categories[0].slug;
  if (!byHandle[initialHandle]) initialHandle = '';
  selectCategory(initialCategory, initialHandle);
})();
